import React from 'react';
import {Card, Row, Table} from 'react-bootstrap';
import _ from 'lodash';
import IndicatorsTable from "./IndicatorsTable";
import {indicatorsType} from "../../../helpers/indicators";

export default function Indicators({ data, acceptedData }) {
  const mapData = (dataObject) => {
      const result = dataObject?.pcs?.map((p) => ({
          ...p,
          ...p.values.reduce((acc, value) => ({
              ...acc,
              [value.year]: value.plan,
          }), {}),
      }))
      //TODO-indicators : можно удалить, после удаления дублей с бека (опишу в задаче)
          const uniqueResult = _.uniqWith(_.map(result,x=>_.omit(x,['id','originId','values'])),_.isEqual)
      return uniqueResult
  }
  const mappedPcs = mapData(data)
  const mappedAcceptedData = mapData(acceptedData)
  const years = _.chain(data.pcs.map((p) => p.values.map((v) => v.year)))
    .flatten().uniq().sort()
    .value();
  const fixedPcs = mappedPcs.filter(x=>!!x.fixedPcId)
  const nonFixedPcs = mappedPcs.filter(x=>!x.fixedPcId)

  return (
      <div>
        <Card className="mb-4">
          <Card.Header as={Card.Title} className="p-4">Показатели</Card.Header>
          <Card.Body className="p-4">
            {!!fixedPcs.length && <IndicatorsTable type={indicatorsType.fixed} data={data} mappedPcs={mappedPcs.filter(x=>!!x.fixedPcId)} mappedAcceptedData={mappedAcceptedData?.filter(x=>!!x.fixedPcId)} years={years}/>}
            {!!nonFixedPcs.length && <IndicatorsTable type={indicatorsType.notFixed} data={data} mappedPcs={mappedPcs.filter(x=>!x.fixedPcId)} mappedAcceptedData={mappedAcceptedData?.filter(x=>!x.fixedPcId)} years={years}/>}
          </Card.Body>
        </Card>
      </div>
    // <div className="read-only">
    //   <Card className="mb-4">
    //     <Card.Header as={Card.Title} className="p-4">Показатели</Card.Header>
    //     <Card.Body className="p-4">
    //     <IndicatorsTable data={data} mappedAcceptedData={mappedAcceptedData.filter(x=>!x.fixedPcId)} mappedPcs={mappedPcs.filter(x=>!x.fixedPcId)} years={years}/>
    //     </Card.Body>
    //   </Card>
    //   <Card className="mb-4">
    //     <Card.Header as={Card.Title} className="p-4">Унифицированные показатели</Card.Header>
    //     <Card.Body className="p-4">
    //       Унифицированные показатели
    //       <IndicatorsTable data={data} mappedAcceptedData={mappedAcceptedData.filter(x=>!x.fixedPcId)} mappedPcs={mappedPcs.filter(x=>!!x.fixedPcId)} years={years}/>
    //     </Card.Body>
    //   </Card>
    // </div>
  );
}
